import { CountryEnum } from './types/country';
import { LocaleEnum } from './types/locale';

export const RCM_INT_COUNTRY_LOCALE_CODE = `${CountryEnum.RCM}-${LocaleEnum.INT}`;
